import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './home';
import NoPage from './noPage'
import VideoPlayer from './projects/videoPlayer';
import Portfolio from './projects/portfolio';
import { BrowserRouter, Route, Routes} from 'react-router-dom';




export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/videoPlayer' element={<VideoPlayer />}></Route>
        <Route path='*' element={<NoPage />}></Route>
        <Route path='/portfolio' element={<Portfolio />}></Route>
      </Routes>
    </BrowserRouter>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
